import { useDispatch, useSelector } from 'react-redux'
import { getReadableDate } from '../../../../helper/date'
import IMessage from 'models/Message'
import {
  markMessagesAsRead, setSelectedMessageId
} from 'redux/reducers/messages'
import { Button } from 'components/Button/Button'
// Tealium
import { Categories } from 'constants/analytics'

import { useTranslation } from 'react-i18next'
import { getUserLoggedInState } from 'redux/reducers/users'
import events, { Event } from 'pubsub/events'

interface MessageProps {
  message: IMessage
  selectedMessageId?: string
  messageType: string
  isInsideOfModal: boolean
}

export const Message: React.FC<MessageProps> = ({ selectedMessageId, message, messageType, isInsideOfModal }) => {
  const dispatch = useDispatch()
  const isLoggedIn = useSelector(getUserLoggedInState)

  const { i18n } = useTranslation('messageCenter')
  const language = i18n.language

  const readableDate = getReadableDate(message?.createdOn, language)

  const onClickMessage = () => {
    // tealium
    const clickEvent: Event = {
      authenticated: isLoggedIn,
      text: message.subject,
      category: Categories.Messages,
      element: 'button',
      messageSubject: message.subject,
      messageStatus: message.read ? 'read' : 'unread',
      eventName: isInsideOfModal ? 'message_center_message_modal_click' : 'message_center_my_messages_click',
      messageComponent: isInsideOfModal ? 'my messages' : 'dropdown',
      activity: 'Link Click',
      url: window.location.href,
      language: i18n.language,
      title: document.title,
      sendToTealium: true,
      sendToCoreAPI: true,
      isMessageCenter: true
    }
    events.publish(clickEvent)

    // send an event for read or open event to core
    const clickEventReadOrOpenMessage: Event = {
      authenticated: isLoggedIn,
      text: message.subject,
      category: Categories.Messages,
      element: 'link',
      messageSubject: message.subject,
      messageStatus: message.read === false ? 'unread' : 'read',
      eventName: 'message_center_message_modal_click',
      messageComponent: 'message modal',
      activity: message.read === false ? 'Message read' : 'Message open',
      url: window.location.href,
      language: i18n.language,
      title: document.title,
      sendToTealium: false,
      sendToCoreAPI: true,
      isMessageCenter: true,
      messageId: message.guid,
      profileId: message.profileId
    }
    events.publish(clickEventReadOrOpenMessage)

    if (messageType.toLowerCase() === 'unread') {
      dispatch(markMessagesAsRead({ messageIds: [message.guid], selectedMessageId: message.guid, isMessageModalOpen: true }))
    } else {
      dispatch(setSelectedMessageId(message.guid))
    }
    const closeButtonRef = document.querySelectorAll('.ch-c-dialog__cross')[0] as HTMLElement
    if (closeButtonRef) {
      closeButtonRef.focus()
    }
  }

  return (
    <div className='ch-u-px--1'>
      <Button aria-expanded={selectedMessageId === message.guid} className='ch-c-message' data-testid='message-preview' onClick={onClickMessage}>
        <span className='ch-c-message__header'>{readableDate}</span>
        {message.read ? message.subject : <strong className='ch-u-font-weight--500'>{message.subject}</strong>}
      </Button>
    </div>
  )
}
